import React from "react";
import { ShoppingCart, AlertTriangle, Package } from "lucide-react";
import type { Product } from "../../types/store";
// import type { Product } from "../../assets/mockProductData";

interface ProductTableProps {
  products: Product[];
  loading: boolean;
  onAddToCart: (product: Product) => void;
}

const ProductTable: React.FC<ProductTableProps> = ({ products, loading, onAddToCart }) => {
  return (
    <div className="lg:w-2/4 overflow-y-scroll bg-white rounded-lg shadow-md overflow-x-auto">
      <table className="min-w-full text-sm  text-left">
        <thead className="bg-blue-100 text-gray-700">
          <tr>
            <th className="px-4 py-2">Name</th>
            {/* <th className="px-4 py-2">Category</th> */}
            <th className="px-4 py-2">Price</th>
            <th className="px-4 py-2">In Stock</th>
            <th className="px-4 py-2">Actions</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            [...Array(5)].map((_, i) => (
              <tr key={i} className="animate-pulse border-b">
                <td className="px-4 py-3"><div className="h-4 bg-gray-200 rounded w-3/4"></div></td>
                {/* <td className="px-4 py-3"><div className="h-4 bg-gray-200 rounded w-1/2"></div></td> */}
                <td className="px-4 py-3"><div className="h-4 bg-gray-200 rounded w-1/3"></div></td>
                <td className="px-4 py-3"><div className="h-4 bg-gray-200 rounded w-1/4"></div></td>
                <td className="px-4 py-3"><div className="h-4 bg-gray-200 rounded w-1/2 ml-auto"></div></td>
              </tr>
            ))
          ) : products.length ? (
            products.map((p) => {
              const isLowStock = p.total_quantity < 5;
              const stockClass = isLowStock ? "text-red-600 font-semibold" : "";
              
              return (
                <tr key={p.id} className={`border-b hover:bg-gray-50 ${isLowStock ? "bg-red-50" : ""}`}>
                  <td className="px-4 py-3">
                    <div className="flex items-center gap-2">
                      {p.image_url ? (
                        <img src={p.image_url} alt={p.name} className="w-8 h-8 rounded object-cover flex-shrink-0" />
                      ) : (
                        <Package size={20} className="text-gray-400 flex-shrink-0" />
                      )}
                      {p.name}
                    </div>
                  </td>
                  {/* <td className="px-4 py-3">{p.category}</td> */}
                  <td className="px-4 py-3 font-medium">₵{p.selling_price}</td>
                  <td className={`px-4 py-3 ${stockClass} flex items-center gap-2`}>
                    {isLowStock && <AlertTriangle size={16} className="text-red-600" />}
                    {p.total_quantity}
                  </td>
                  <td className="px-4 py-3 text-center">
                    <button
                      className="px-2 py-1 bg-primary hover:bg-blue-900 rounded-md text-white flex items-center gap-1"
                      onClick={() => onAddToCart(p)}
                    >
                      <ShoppingCart size={16} /> Add
                    </button>
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan={5} className="text-center py-6 text-gray-500 italic">
                No products available
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ProductTable;
